(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bs-ref"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.nqBs) return;
    var KEY = 'nq:bcv';
    var TTL = 30 * 60 * 1000;
    var ENDPOINT = 'https://ve.dolarapi.com/v1/dolares/oficial';
    var rate = null;
    var fmt = new Intl.NumberFormat('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    function render() {
      if (!rate) return;
      document.querySelectorAll('[data-bs-ref]').forEach(function (el) {
        var cents = parseFloat(el.dataset.cents);
        if (!(cents > 0)) { el.hidden = true; return; }
        el.querySelector('[data-bs-ref-value]').textContent = 'Bs ' + fmt.format((cents / 100) * rate);
        el.hidden = false;
      });
    }

    function load() {
      try {
        var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
        if (c && c.r > 0 && Date.now() - c.t < TTL) { rate = c.r; render(); return; }
      } catch (e) {}
      fetch(ENDPOINT, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (d) {
          var n = parseFloat(d && d.promedio);
          if (!(n > 0)) return;
          rate = n;
          try { sessionStorage.setItem(KEY, JSON.stringify({ r: n, t: Date.now() })); } catch (e) {}
          render();
        })
        .catch(function () {});
    }

    window.nqBs = { render: render };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
    else load();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["carousel-nav"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (vp) => {
      if (vp.dataset.carouselNav === 'on') return;
      const track = vp.querySelector('[data-recom-track]');
      const prev = vp.querySelector('[data-recom-prev]');
      const next = vp.querySelector('[data-recom-next]');
      if (!track || (!prev && !next)) return;
      vp.dataset.carouselNav = 'on';

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const go = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.7, behavior: reduce ? 'auto' : 'smooth' });
      prev?.addEventListener('click', () => go(-1));
      next?.addEventListener('click', () => go(1));

      let frame = 0;
      const update = () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          // Margen de 24px: el scroll-snap y el padding del track dejan
          // el inicio unos pixeles corrido aunque no se haya desplazado
          const max = track.scrollWidth - track.clientWidth;
          if (prev) prev.hidden = track.scrollLeft <= 24;
          if (next) next.hidden = max <= 24 || track.scrollLeft >= max - 24;
        });
      };

      track.addEventListener('scroll', update, { passive: true });
      // El track cambia de tamaño o de contenido cuando cargan los productos
      new ResizeObserver(update).observe(track);
      new MutationObserver(update).observe(track, { childList: true });
      update();
    };

    const scan = (root = document) => root.querySelectorAll('[data-recom-viewport]').forEach(init);
    scan();
    // Editor de temas: la seccion se vuelve a renderizar al editarla
    document.addEventListener('shopify:section:load', (e) => scan(e.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-badges"] && !Shopify.designMode) return;
  try {
    // Etiquetas NQ del título: si una tarjeta tiene varias, se turnan deslizando
  // a la izquierda cada 2,6 s. Un solo temporizador para todas las tarjetas;
  // se detiene con la pestaña oculta, fuera de pantalla o con movimiento reducido.
  (function () {
    if (window.__nqTags) return;
    window.__nqTags = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function prep(el) {
      if (el.dataset.nqReady) return true;
      var track = el.firstElementChild;
      var tags = Array.prototype.slice.call(track.querySelectorAll(':scope > .nq-tag'));
      if (!tags.length) return false;
      var w = 0;
      tags.forEach(function (t) { w = Math.max(w, t.getBoundingClientRect().width); });
      if (!w) return false;
      tags.forEach(function (t) {
        var slot = document.createElement('span');
        slot.className = 'nq-tags__slot';
        slot.style.width = w + 'px';
        t.parentNode.insertBefore(slot, t);
        slot.appendChild(t);
      });
      el.style.width = w + 'px';
      el.dataset.nqReady = '1';
      el.dataset.k = '0';
      return true;
    }

    function tick() {
      if (document.hidden) return;
      var vh = window.innerHeight;
      document.querySelectorAll('[data-nq-tags]').forEach(function (el) {
        if (!prep(el) || reduce.matches) return;
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var track = el.firstElementChild;
        var n = track.children.length;
        var k = (parseInt(el.dataset.k, 10) + 1) % n;
        el.dataset.k = String(k);
        track.style.transform = 'translateX(' + (-parseFloat(el.style.width) * k) + 'px)';
      });
    }
    setInterval(tick, 2600);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-media"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pcVideoHoverInit) return;
    window.__pcVideoHoverInit = true;

    var hasHover = window.matchMedia('(hover: hover)').matches;

    function play(video) {
      if (!video) return;
      if (video.preload !== 'auto') {
        video.preload = 'auto';
        try { video.load(); } catch (e) {}
      }
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function stop(video) {
      if (!video) return;
      try {
        video.pause();
        video.currentTime = 0;
      } catch (e) {}
    }

    // ===== Desktop: hover del card =====
    // Event delegation con mouseover/mouseout: 2 listeners para toda la pagina,
    // funciona con cards inyectadas async sin MutationObserver.
    if (hasHover) {
      document.addEventListener('mouseover', function (e) {
        var card = e.target.closest && e.target.closest('[data-product-card]');
        if (!card || card._pcVideoHovering) return;
        var video = card.querySelector('[data-pc-video]');
        if (!video) return;
        card._pcVideoHovering = true;
        play(video);
      });

      document.addEventListener('mouseout', function (e) {
        var card = e.target.closest && e.target.closest('[data-product-card]');
        if (!card || !card._pcVideoHovering) return;
        // Solo pausar si el mouse realmente salio del card (no de un hijo).
        var related = e.relatedTarget;
        if (related && card.contains(related)) return;
        card._pcVideoHovering = false;
        var video = card.querySelector('[data-pc-video]');
        stop(video);
      });
    }

    // ===== Mobile: 1 solo video activo (el mas centrado del viewport) =====
    // Un solo IntersectionObserver observa todos los videos existentes y
    // se re-observa cuando aparecen nuevos.
    // Sin autoplay si el cliente pidio ahorrar datos o tiene conexion lenta.
    var conn = navigator.connection || {};
    var slow = conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || '');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!hasHover && !slow && !reduceMotion && 'IntersectionObserver' in window) {
      var active = null;
      var debounceTimer = null;

      function pickBest() {
        var best = null;
        var bestRatio = 0.6; // umbral minimo
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var videos = document.querySelectorAll('[data-pc-video]');
        for (var i = 0; i < videos.length; i++) {
          var r = videos[i].getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) continue;
          var visible = Math.min(r.bottom, vh) - Math.max(r.top, 0);
          var ratio = visible / Math.max(1, r.height);
          if (ratio > bestRatio) { bestRatio = ratio; best = videos[i]; }
        }
        if (best === active) return;
        if (active) {
          var prevMedia = active.closest('.product-card__media');
          if (prevMedia) prevMedia.classList.remove('is-video-playing');
          stop(active);
        }
        active = best;
        if (active) {
          var media = active.closest('.product-card__media');
          if (media) media.classList.add('is-video-playing');
          play(active);
        }
      }

      function schedule() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(pickBest, 180);
      }

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          if (active) stop(active);
        } else {
          schedule();
        }
      });

      // Init cuando el DOM este listo.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', schedule);
      } else {
        schedule();
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["share-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    const enc = (s) => encodeURIComponent(String(s || ''));

    // Toast global (uno solo, reusable)
    let toastEl = null;
    function showToast(msg) {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'share-btns__toast';
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = msg;
      toastEl.classList.add('is-visible');
      clearTimeout(toastEl.__t);
      toastEl.__t = setTimeout(() => toastEl.classList.remove('is-visible'), 2000);
    }

    async function buildDynUrl(root) {
      const dyn = root.dataset.shareDyn;
      const origin = window.location.origin;

      if (dyn === 'cart') {
        // Permalink Shopify: /cart/{variant}:{qty},{variant}:{qty}
        try {
          const r = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
          if (!r.ok) return origin + '/cart';
          const cart = await r.json();
          if (!cart.items || !cart.items.length) return origin + '/cart';
          const parts = cart.items.map(i => `${i.variant_id}:${i.quantity}`);
          return origin + '/cart/' + parts.join(',');
        } catch (_) { return origin + '/cart'; }
      }

      if (dyn === 'wishlist') {
        // Toma la lista del localStorage (theme usa 'nqln:wishlist') y comparte
        // los handles (nqln:wishlist:handles): con IDs la pagina no puede leer
        // los productos.
        try {
          const stored = localStorage.getItem('nqln:wishlist') || localStorage.getItem('nqln_wishlist');
          const ids = stored ? JSON.parse(stored) : [];
          if (!Array.isArray(ids) || !ids.length) return origin + '/pages/wish-list';
          let handles = {};
          try { handles = JSON.parse(localStorage.getItem('nqln:wishlist:handles') || '{}') || {}; } catch (_) {}
          const items = ids.map((id) => handles[id] || id).map(encodeURIComponent);
          return origin + '/pages/wish-list?share=' + items.join(',');
        } catch (_) { return origin + '/pages/wish-list'; }
      }

      return origin + window.location.pathname;
    }

    // Posiciona el menu (position:fixed) arriba o abajo del trigger segun
    // el espacio disponible. Escape del overflow del cart drawer.
    function positionMenu(trigger, menu) {
      const rect = trigger.getBoundingClientRect();
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      // Medir el menu ya visible
      const menuRect = menu.getBoundingClientRect();
      const menuH = menuRect.height || 160;
      const menuW = menuRect.width || 220;

      const spaceBelow = vh - rect.bottom;
      const openUp = spaceBelow < menuH + 16;

      // Vertical
      if (openUp) {
        menu.style.top = Math.max(8, rect.top - menuH - 6) + 'px';
      } else {
        menu.style.top = (rect.bottom + 6) + 'px';
      }

      // Horizontal: alinear al derecho del trigger, sin salirse del viewport
      let left = rect.right - menuW;
      if (left < 8) left = 8;
      if (left + menuW > vw - 8) left = vw - menuW - 8;
      menu.style.left = left + 'px';
      menu.style.right = 'auto';
    }

    async function getShareData(root) {
      const title = root.dataset.shareTitle || '';
      const text = root.dataset.shareText || '';
      const url = root.dataset.shareUrl || await buildDynUrl(root);
      return { title, text, url };
    }

    // En mobile intentamos primero el share nativo del OS (Web Share API).
    // Si no esta disponible o falla (no cancel), caemos al dropdown propio.
    // En desktop siempre dropdown.
    document.addEventListener('click', async (e) => {
      const trigger = e.target.closest('[data-share-trigger]');
      if (trigger) {
        e.preventDefault();
        const root = trigger.closest('[data-share-btns]');

        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        if (isMobile && typeof navigator.share === 'function') {
          try {
            const data = await getShareData(root);
            if (!navigator.canShare || navigator.canShare(data)) {
              await navigator.share(data);
              return;
            }
          } catch (err) {
            // AbortError = user cancelo, no hacemos nada. Otro error = fallback al dropdown.
            if (err && err.name === 'AbortError') return;
          }
        }
        // Vincular root <-> menu con owner id, para reencontrarlo tras portalear
        if (!root.dataset.shareOwnerId) {
          const oid = 'sb-' + Math.random().toString(36).slice(2, 9);
          root.dataset.shareOwnerId = oid;
          const innerMenu = root.querySelector('[data-share-menu]');
          if (innerMenu) innerMenu.dataset.shareOwner = oid;
        }
        const menu = root.querySelector('[data-share-menu]')
          || document.querySelector('[data-share-menu][data-share-owner="' + root.dataset.shareOwnerId + '"]');
        if (!menu) return;

        // Toggle menú
        const isOpen = !menu.hidden;
        // Cerrar otros menús abiertos
        document.querySelectorAll('[data-share-menu]').forEach(m => { m.hidden = true; });
        document.querySelectorAll('[data-share-trigger]').forEach(t => t.setAttribute('aria-expanded', 'false'));
        if (!isOpen) {
          // Portal a body: el cart drawer tiene transform en el panel, lo
          // que rompe position:fixed. Mover el menu a body lo aisla.
          if (menu.parentElement !== document.body) {
            root.dataset.shareMenuPortaled = '1';
            document.body.appendChild(menu);
          }
          menu.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          positionMenu(trigger, menu);
          // Preparar hrefs de las opciones
          const data = await getShareData(root);
          const wa = root.querySelector('[data-share-wa]');
          const email = root.querySelector('[data-share-email]');
          const message = data.text ? `${data.text} ${data.url}` : data.url;
          if (wa) wa.href = 'https://wa.me/?text=' + enc(message);
          if (email) email.href = 'mailto:?subject=' + enc(data.title) + '&body=' + enc(message);
          // Guardar url en menu (que puede estar portaled fuera del root)
          menu.dataset.shareUrlResolved = data.url;
        }
        return;
      }

      // Cerrar menú al click afuera (tampoco cerrar si es click dentro del menu portaled)
      if (!e.target.closest('[data-share-btns]') && !e.target.closest('[data-share-menu]')) {
        document.querySelectorAll('[data-share-menu]').forEach(m => { m.hidden = true; });
        document.querySelectorAll('[data-share-trigger]').forEach(t => t.setAttribute('aria-expanded', 'false'));
      }

      // Botón copiar
      const copyBtn = e.target.closest('[data-share-copy]');
      if (copyBtn) {
        e.preventDefault();
        const menuEl = copyBtn.closest('[data-share-menu]');
        const url = (menuEl && menuEl.dataset.shareUrlResolved) || '';
        try {
          await navigator.clipboard.writeText(url);
          const label = copyBtn.querySelector('[data-share-copy-label]');
          if (label) {
            const orig = label.textContent;
            label.textContent = '¡Copiado!';
            copyBtn.classList.add('is-copied');
            setTimeout(() => { label.textContent = orig; copyBtn.classList.remove('is-copied'); }, 1500);
          }
          showToast('Link copiado');
        } catch (_) {
          // Fallback: seleccionar en un textarea temporal
          const ta = document.createElement('textarea');
          ta.value = url;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); showToast('Link copiado'); } catch (_) {}
          document.body.removeChild(ta);
        }
      }
    });

    // Escape cierra los menús
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-share-menu]').forEach(m => { m.hidden = true; });
        document.querySelectorAll('[data-share-trigger]').forEach(t => t.setAttribute('aria-expanded', 'false'));
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["whatsapp-smart"] && !Shopify.designMode) return;
  try {
    /* WhatsApp inteligente: al tocar, rehace el mensaje con la URL actual
     (incluye ?variant= si el cliente cambio de variante). */
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('[data-wa-smart]');
    if (!link) return;
    const template = link.getAttribute('data-wa-template') || '';
    const phone = link.getAttribute('data-wa-phone');
    if (!phone) return;
    const url = window.location.href.split('#')[0];
    const text = template.replace('[url]', url);
    link.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(text);
  });
  } catch(e) { console.error(e); }
})();

})();
